import { bindable, autoinject } from 'aurelia-framework';
import { State } from '../../../services/global-state';
import { PayrazrService } from '../../../services/payrazr';
import { I18N } from 'aurelia-i18n';

@autoinject
export class EmailReceiptSender {
	@bindable isPaymentPlanEmailOption: boolean = false;
	@bindable customerAccountNumber: any;
	@bindable bucketKey: number = null;
	@bindable hasScheduledInReceipt: boolean = false;
	@bindable applyTemplateRequest: any;
	element: Element;
	payrazr: any;
	globalState: any;
	allowConsumerToUpdateTheEmail: any;
	allowConsumerToRequestAnEmailReceipt: any;
	emailAddress: any;
	emailMessage: any;
	emailValidation: any;
	runPlannedPaymentDays: any;
	sendPlanReceiptToMerchant: any;
	merchantConfiguredReceiptEmails: any;
	receiptSubject: any;
	isEmailAddress: any;
	emailSent: any;
	profileLink: string;
	preferencesLink: string;
	changeNotificationPreferences: string;

	constructor(element: Element, payrazr: PayrazrService, globalState: State, private i18n: I18N) {
		this.element = element;
		this.payrazr = payrazr;
		this.globalState = globalState;
		this.allowConsumerToUpdateTheEmail = (this.globalState.customer && this.globalState.customer.notificationSettings) ? this.globalState.customer.notificationSettings.isEmailOptedIn : false;
		this.allowConsumerToRequestAnEmailReceipt = this.globalState.business.portalSettings.allowConsumerToRequestAnEmailReceipt;
		this.emailAddress = this.globalState.customer.email;

		this.emailMessage = null;
		this.emailValidation = null;
		this.runPlannedPaymentDays = this.globalState.business.runPlannedPaymentDays;

		//todo: this should probably be handled on the API
		this.sendPlanReceiptToMerchant = this.globalState.business.portalSettings.sendPlanReceiptToMerchant;
		this.merchantConfiguredReceiptEmails = this.globalState.business.portalSettings.merchantConfiguredReceiptEmails;


		const portalUrl = this.globalState.business.portalSettings.url;
		this.preferencesLink = `<a href="${portalUrl}/secure/preferences">${this.i18n.i18next.t('preferences', 'Preferences')}</a>`;
		this.profileLink = this.i18n.i18next.t('receiveEmailRemindersForUpcomingScheduleedPaymentsVisitProfilePage', {defaultValue:  `If you would like to receive email reminders for upcoming scheduled payments,
			please visit the ${this.preferencesLink} page and change your selection in the "Notifications Preferences" Section.`, link: this.preferencesLink});

		this.changeNotificationPreferences = this.i18n.i18next.t('portalOptOutEmailNotifications', {
			defaultValue:  `If you would like to opt-out of receiving email notifications, please visit the ${this.preferencesLink}
							page and change your selection in the "Notifications Preferences" Section.`,
			link: this.preferencesLink
		});
	}

	applyTemplateRequestChanged(newValue: any, oldValue: any) {
		if (newValue && this.applyTemplateRequest && this.hasScheduledInReceipt) {
			this.sendUnderlyingPlanReceiptEmail();
		}
	}

	sendUnderlyingPlanReceiptEmail() {
		if (this.isPaymentPlanEmailOption && this.sendPlanReceiptToMerchant) {
			this.receiptSubject = "{MerchantName} Confirmation of Payment Plan";
			var fromAddress = ""; //This is overridden by the RestfulAPI service
			var toAddress = this.merchantConfiguredReceiptEmails;
			var subject = this.receiptSubject;
			var customerAccountNumber = this.customerAccountNumber;

			this.applyTemplateRequest.isForNotification = true;
			return this.payrazr.sendEmailWithApplyTemplateRequest(fromAddress, toAddress, subject, this.applyTemplateRequest, customerAccountNumber, this.bucketKey)
				.then(response => {
				})
				.catch(error => {
				});
		}
	}

	sendEmail() {
		this.emailMessage = null;
		this.emailValidation = null;
		this.receiptSubject = this.isPaymentPlanEmailOption ? "{MerchantName} Confirmation of Payment Plan" : "{MerchantName} Receipt of Payment";
		var fromAddress = ""; //This is overridden by the RestfulAPI service
		var toAddress = this.emailAddress;
		var subject = this.receiptSubject;
		
		var customerAccountNumber = this.customerAccountNumber;

		if (!this.validate()) {
			this.emailValidation = this.i18n.i18next.t('thisEmailAddressIsNotValid', 'This Email address is not valid.');
			this.isEmailAddress = false;
			return false;
		} else {
			this.emailValidation = this.i18n.i18next.t('thisEmailAddressIsValid', 'This Email address is valid.');
			this.isEmailAddress = true;
		}

		this.applyTemplateRequest.isForNotification = true;
		return this.payrazr.sendEmailWithApplyTemplateRequest(fromAddress, toAddress, subject, this.applyTemplateRequest, customerAccountNumber, this.bucketKey)
			.then(response => {
				this.emailSent = true;
				this.emailMessage = this.i18n.i18next.t('receiptEmailSuccessful', 'Your receipt has been emailed to the address provided.');
			})
			.catch(error => {
				this.emailMessage = this.i18n.i18next.t('receiptEmailFailed', 'We\'re sorry, there was a problem sending your email receipt. Please contact customer service or you may print the receipt for your records.');
				this.emailSent = false;
			});
	}

	updateEmail() {
		if (!this.validate()) {
			this.emailValidation = this.i18n.i18next.t('thisEmailAddressIsNotValid', 'This Email address is not valid.');
			this.isEmailAddress = false;
			return false;
		} else {
			this.emailValidation = this.i18n.i18next.t('thisEmailAddressIsValid', 'This Email address is valid.');
			this.isEmailAddress = true;
		}
		this.payrazr.updateEmailInfo(this.emailAddress, this.allowConsumerToUpdateTheEmail)
			.then(() => {
				this.isEmailAddress = true;
				this.emailValidation = 'Update was successful';
			})
			.catch(response => {
				response
					.json()
					.then(error => {
						this.isEmailAddress = false;
						this.emailMessage = `Update was unsuccessful: ${error}`;
					});
			});

	}

	validate() {
		var email = this.emailAddress;
		return this.payrazr.validateEmail(email);
	}
}
